export const sharedComponentTokens = {};
